export const bulkTransferSiteCoreKeys = {
  bulkTransferKey: "ProgramsAndParticipants.BulkTransferParticipants",

  //stepper keys
  bulkTransferStepperKeys:
    "ProgramsAndParticipant.BulkTransferParticipants.ProgressBarComponent",
  participantProgressState:
    "BulkTransferParticipants.ProgressBarComponent.ParticipantProgressState",
  transferDetailsProgressState:
    "BulkTransferParticipants.ProgressBarComponent.TransferDetailsProgressState",
  processingProgress:
    "BulkTransferParticipants.ProgressBarComponent.ProcessingProgressState",
  processingYourRecordsMessage:
    "BulkTransferParticipants.ProgressBarComponent.ProcessingYourRecordsMessage",
  successProgressState:
    "BulkTransferParticipants.ProgressBarComponent.SuccessProgressState",
  letsStart: "BulkTransferParticipants.ProgressBarComponent.LetsStart",
  chooseDestinationCountryMessage:
    "BulkTransferParticipants.ProgressBarComponent.ChooseDestinationCountryMessage",
  almostThere: "BulkTransferParticipants.ProgressBarComponent.AlmostThere",
  chooseCompatibleProgramTemplateMessage:
    "BulkTransferParticipants.ProgressBarComponent.ChooseCompatibleProgramTemplateMessage",
  youAreDoneHoldOn:
    "BulkTransferParticipants.ProgressBarComponent.YouareDone-HoldOn",
  youAreDone: "BulkTransferParticipants.ProgressBarComponent.YouareDone",
  unprocessedParticipantMessage:
    "BulkTransferParticipants.ProgressBarComponent.UnprocessedParticipantMessage",
  processIcon: "BulkTransferParticipants.ProgressBarComponent.ProcessIcon",

  //transfer type
  transferTypeKey:
    "ProgramsAndParticipant.BulkTransferParticipants.TransferType",
  chooseType: "BulkTransferParticipants.TransferType.ChooseType",
  changeProgramRadioButton:
    "BulkTransferParticipants.TransferType.ChangeProgramRadioButton",
  changeCountryRadioButton:
    "BulkTransferParticipants.TransferType.ChangeCountryRadioButton",

  //search participant form keys
  chooseParticipantMessage:
    "BulkTransferParticipants.ProgressBarComponent.ChooseParticipantMessage",
  searchParticipantsKey:
    "ProgramsAndParticipant.BulkTransferParticipants.SearchParticipants",
  deliveryCountry:
    "BulkTransferParticipants.SearchParticipants.DeliveryCountry",
  client: "BulkTransferParticipants.SearchParticipants.Client",
  nextView: "BulkTransferParticipants.SearchParticipants.NextView",
  productLine: "BulkTransferParticipants.SearchParticipants.ProductLine",
  programTemplate:
    "BulkTransferParticipants.SearchParticipants.ProgramTemplate",
  resetSearch: "BulkTransferParticipants.SearchParticipants.ResetSearch",
  filterByList: "BulkTransferParticipants.SearchParticipants.FilterByList",
  filterByContains: "FilterBy.Contains",

  //result keys
  searchParticipantsResultsKey:
    "ProgramsAndParticipant.BulkTransferParticipants.SearchParticipantsResults",
  participantName:
    "BulkTransferParticipants.SearchParticipantsResults.ParticipantName",
  resultDeliveryCountry:
    "BulkTransferParticipants.SearchParticipantsResults.DeliveryCountry",
  resultProductLine:
    "BulkTransferParticipants.SearchParticipantsResults.ProductLine",
  resultProgramTemplate:
    "BulkTransferParticipants.SearchParticipantsResults.ProgramTemplate",
  resultClient: "BulkTransferParticipants.SearchParticipantsResults.Client",
  resultNextView: "BulkTransferParticipants.SearchParticipantsResults.NextView",
  chooseParticipants:
    "BulkTransferParticipants.SearchParticipantsResults.ChooseParticipants",
  participantsSelectedDropDownText:
    "BulkTransferParticipants.SearchParticipantsResults.ParticipantsSelectedDropDownText",
  selectSearchParameterErrorMessage:
    "BulkTransferParticipants.SearchParticipantsResults.SelectSearchParameter-ErrorMessage",
  changeTransferTypeConfirmationMessage:
    "BulkTransferParticipants.TransferType.ChangeTransferType-ConfirmationMessage",
  allParticipants:
    "BulkTransferParticipants.SearchParticipantsResults.AllParticipants",
  twoParticipantsRequired:
    "BulkTransferParticipants.SearchParticipantsResults.AtLeastTwoParticipantsToContinue",

  //step 2 results keys
  selectedParticipantsHeader:
    "BulkTransferParticipants.SearchParticipantsResults.SelectedParticipantsHeader",
  addParticipantsLink:
    "BulkTransferParticipants.SearchParticipantsResults.AddParticipantsLink",
  action: "BulkTransferParticipants.SearchParticipantsResults.Action",
  minimumTwoParticipantsRequired:
    "BulkTransferParticipants.SearchParticipantsResults.MinimumTwoParticipantsRequired",
  deleteParticipantConfirmation:
    "BulkTransferParticipants.SearchParticipantsResults.DeleteParticipantConfirmation",
  participantDeletedToastMessage:
    "BulkTransferParticipants.SearchParticipantsResults.ParticipantDeletedToastMessage",

  //transfer details
  transferDetailsKey:
    "ProgramsAndParticipant.BulkTransferParticipants.TransferDetails",
  programsAndCandidatesTransferDetailsKey:
    "ProgramsAndCandidates.ParticipantTransfer.TransferDetails",
  countryTransfer:
    "ParticipantTransfer.TransferDetails.TransferDetails-CountryTransfer",
  programTransfer:
    "ParticipantTransfer.TransferDetails.TransferDetails-ProgramTransfer",
  compatibleProgramTemplate:
    "ParticipantTransfer.TransferDetails.CompatibleProgramTemplate",
  deliveryOffice: "ParticipantTransfer.TransferDetails.DeliveryOffice",
  destinationCountry: "ParticipantTransfer.TransferDetails.DestinationCountry",
  nextLanguage: "ParticipantTransfer.TransferDetails.NEXTLanguage",
  bulkTransferConfirmationMessage:
    "ParticipantTransfer.TransferDetails.BulkTransferConfirmationMessage",
  noCompatibleProgramTemplateAlertMessage:
    "ParticipantTransfer.TransferDetails.NoCompatibleProgramTemplate-AlertMessage",

  //summaryTable
  bulkTransferSummary:
    "ProgramsAndParticipant.BulkTransferParticipants.BulkTransferSummaryTable",
  processed:
    "BulkTransferParticipants.BulkTransferSummaryTable.Processed-TableHeader",
  unProcessed:
    "BulkTransferParticipants.BulkTransferSummaryTable.Unprocessed-TableHeader",
  sourceProgramTemplate:
    "BulkTransferParticipants.BulkTransferSummaryTable.SourceProgramTemplate",
  sourceCountry:
    "BulkTransferParticipants.BulkTransferSummaryTable.SourceCountry",
  failureReason:
    "BulkTransferParticipants.BulkTransferSummaryTable.FailureReason",
  destinationCountrySummaryTransfer:
    "BulkTransferParticipants.BulkTransferSummaryTable.DestinationCountry",
  bulkCountryTransfer:
    "BulkTransferParticipants.BulkTransferSummaryTable.SummaryHeader-CountryTransfer",
  bulkProgramTransfer:
    "BulkTransferParticipants.BulkTransferSummaryTable.SummaryHeader-ProgramTransfer",

  bulkParticipantSummary:
    "ProgramsAndCandidates.BulkParticipantSummary.ParticipantSummary",
  refreshStatusLink:
    "BulkParticipantSummary.ParticipantSummary.RefreshStatusLink",
  totalNumberOfRecords:
    "BulkParticipantSummary.ParticipantSummary.TotalNumberOfRecords",
  processedRecords:
    "BulkParticipantSummary.ParticipantSummary.ProcessedRecords",
  addNewBulkLink:
    "BulkParticipantSummary.ParticipantSummary.AddNewBulkActivityLink",
  yourParticipantRecordIsProcessingMessage:
    "BulkParticipantSummary.ParticipantSummary.YourParticipantRecordIsProcessingMessage",
  totalNumberOfProgramsIcon:
    "BulkParticipantSummary.ParticipantSummary.TotalNumberofProgramsIcon",

  bulkProcessDetails: "ProgramsAndParticipant.BulkProcess.BulkProcessDetails",
  bulkProcessNamePlaceholderText:
    "BulkProcess.BulkProcessDetails.BulkProcessNamePlaceholderText",
  bulkProcessName: "BulkProcess.BulkProcessDetails.BulkProcessName",
};
